export type UpdateTicketStatusMemoResponse = {
  updateDateTime: string;
};
